import React, { Component } from 'react';
import Input from 'common/components/core/input';
import { translate } from 'react-i18next';

class DefaultFilter extends Component {
    render() {
        const { theme, className, filter, onChange, t } = this.props;
        return (
            <Input
                className={className}
                theme={theme}
                value={(filter && filter.value) || ''}
                onChange={onChange}
                clearableInput
                placeholder={t('search')}
            />
        );
    }
}

export default translate()(DefaultFilter);
